import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { DateRange } from 'yt-ng-framework';
import { BaseEntity } from 'yt-ng-framework';

export class ResenjeZaPlacenoOdsustvo extends BaseEntity {
  constructor() {
      super();
  }
  
  OsobaID: number = null;
  OsnovID: number = null;
  PodVrstaDokumentaStavkaID: number = null;
  Godina: number = null;
  BrojDokumenta: string = null;
  Datum: Date = null;
  OdDatuma: NgbDate = null;
  DoDatuma: NgbDate = null;
  Period: DateRange=new DateRange();
  Dana: number = null;
  DatumPocetkaRada: NgbDate = null;
  DatumZahteva: Date = null;
  Napomena: string = null;
  Url: string=null;

  Deserialize(input: any) {
    this.ID = input.ID;
    this.OsobaID = input.OsobaID;
    this.OsnovID = input.OsnovID;
    this.PodVrstaDokumentaStavkaID = input.PodVrstaDokumentaStavkaID;
    this.BrojDokumenta = input.BrojDokumenta;
    this.Datum = input.Datum;
    this.OdDatuma = input.OdDatuma;
    this.DoDatuma = input.DoDatuma;
    this.Period.FromDate=input.OdDatuma;
    this.Period.ToDate=input.DoDatuma;
    this.Dana = input.Dana;
    this.DatumPocetkaRada = input.DatumPocetkaRada;
    this.DatumZahteva = input.DatumZahteva;
    this.Napomena = input.Napomena;
    return this;
  }

  Serialize(input: ResenjeZaPlacenoOdsustvo) {
    input.OdDatuma=input.Period.FromDate;
    input.DoDatuma=input.Period.ToDate;
    return input;
  }
}
